var render = function render(_c,_vm){return _c('r-video',{ref:"video",staticClass:"candy-planets-video",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":640,"height":510,"cover":"","loop":"","autoplay":"","src-root":"/video/candy-planets"}})
}
var staticRenderFns = []

export { render, staticRenderFns }